export { locations };

const locations = () => {

    document.addEventListener('click', ({ target }) => {
        if (target.closest('.sub-menu') && ((target.href.includes('#offices') || target.href.includes('#warehouses')))) {
            window.location.replace(target.getAttribute('href'));
            location.reload();
        }
    });

    const locationTabs = document.querySelector('.location-tabs'),
          links = document.querySelectorAll('.we-operate a');

    let locationTab = '',
        locationCountry = '';

    const displayLocations = () => {
        const tabContent = $(`.location-${locationTab}`),
              tabContentCols = $(`.location-${locationTab} > .wp-block-columns > .wp-block-column`),
              tabContentColsHeight = [],
              bbLocations = [];
              
        let locationCountryXY;

        // ? remove previous active and apply new active for tab
        $(locationTabs).find('.active-tab').removeClass('active-tab');
        $(locationTabs).find(`.tab-${locationTab}`).addClass('active-tab');

        $('.wp-block-lazyblock-offices-warehouses-list').hide();
        tabContentCols.removeClass('minimized');
        tabContent.show();

        tabContentCols.each((idx, col) => {
            tabContentColsHeight.push(col.clientHeight);

            // ? if url has country slug then keep corresponding col opened
            if (!col.classList.contains('url-location')) {

                col.classList.add('minimized');
            } else {
                locationCountryXY = [Number(col.getAttribute('data-x')), Number(col.getAttribute('data-y'))];
                col.classList.remove('url-location');
            }

            col.setAttribute('column-id', idx);

            bbLocations.push([Number(col.getAttribute('data-x')), Number(col.getAttribute('data-y'))]);

            $(col).find('h4').first().off('click').on('click', function() {
                let locationSlug = this.parentElement.getAttribute('data-slug'),
                    currentSlug,
                    coordX,
                    coordY,
                    pageType;

                if (window.location.href.indexOf('#offices') !== -1) {
                    pageType = '/locations/#offices';
                } else if (window.location.href.indexOf('#warehouses') !== -1) {
                    pageType = '/locations/#warehouses';
                } else {
                    pageType = '/locations/#offices';
                }

                let pageLang;
                switch($('html').attr('lang')) {
                    case 'en-US':
                        pageLang = '';
                        break;
                    case 'fi':
                        pageLang = '/fi';
                        break;
                    case 'sv-SE':
                        pageLang = '/sv';
                        break;
                    case 'ru-RU':
                        pageLang = '/ru';
                        break;
                }

                currentSlug = `${pageLang}${pageType}.${locationSlug}`
                history.pushState(null, null, currentSlug);

                $(tabContentCols).not(this.parentElement).addClass('minimized');
                this.parentElement.classList.toggle('minimized');
                this.nextElementSibling.style.maxHeight = tabContentColsHeight[this.parentElement.getAttribute('column-id')] + 'px';

                coordX = Number(this.parentElement.getAttribute('data-x'));
                coordY = Number(this.parentElement.getAttribute('data-y'));

                if (this.parentElement.classList.contains('minimized')) {
                    initMap(bbLocations, 'location-map');
                } else {
                    initMap(false, 'location-map', coordX, coordY);
                }
            })
        })
        
        if (locationCountryXY) {
            initMap(false, 'location-map', locationCountryXY[0], locationCountryXY[1]);
        } else {
            initMap(bbLocations, 'location-map');
        }
    }

    const grabLocation = (target) => {
        if (target) {
            locationTab = target;
        } else if (window.location.hash !== '') {
            let locationHash = window.location.hash.substring(1),
                hashPieces = locationHash.split('.');

            locationTab = hashPieces[0],
            locationCountry = hashPieces[1];             
        }

        // ? look for all columns with given country slug from url
        $(`.location-${locationTab} > .wp-block-columns > .wp-block-column`).each((idx, col) => {
            let colSlug = col.getAttribute('data-slug');
            if (colSlug === locationCountry) {
                col.classList.add('url-location');
            }
        })
    }

    if (locationTabs) {
        links.forEach(link => {
            link.addEventListener('click', function() {
                // ? if we click a link on a page that is not a tab (we operate in... links)
                if (!this.parentElement.classList.contains('tab-offices') && 
                    !this.parentElement.classList.contains('tab-warehouses')) {
                    window.location.replace(this.getAttribute('href'));
                    location.reload();
                }
            })
        })

        locationTab = 'offices';
        grabLocation();
    }

    $(locationTabs).on('click', (event) => {
        const { target } = event;
        locationCountry = '';
        grabLocation(target.getAttribute('href').substring(1));
        displayLocations();
    })

    if (locationTab) {
        displayLocations();

        if (locationCountry) {
            let currentLocation = $(`div[data-slug="${locationCountry}"]`);
        }
    }

    if (document.getElementById('contact-map')) {
        initMap();
    }
}